import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'

import styles from './styles.module.scss'
import cn from 'classnames'

import { RatingStarSvg } from '../../../../UI/Icons/RatingStarSvg'
import { MailSvg } from '../../../../UI/Icons/MailSvg'
import noAvatar from '../../../../assets/images/no-avatar.svg'
import { profilePaths } from '../../../../constants/constans'

import ImageComponent from '../../../../UI/Image/ImageComponent'
import UseSmartTooltip from '../../../../hooks/useSmartTooltip'
import { ReactComponent as ArrowLeftSvg } from '../../../../assets/icons/chatArrow.svg'
export const Header = memo(({ interlocutor, isOnline, companyName, email }) => {
  const firstName = interlocutor?.name?.split(' ')[1] || null
  const history = useHistory()

  const handleBack = () => {
    history.push(profilePaths.chat)
  }

  return (
    <div className={styles.header}>
      <button className={styles.backButton} onClick={handleBack} aria-label='Go back'>
        <ArrowLeftSvg style={{ width: '35px', height: '35px' }} />
      </button>
      <div className={styles.wrapper}>
        <ImageComponent
          className={cn(styles.avatar, { [styles.avatar__online]: isOnline })}
          src={interlocutor.avatar ?? noAvatar}
          alt='user avatar'
        />
        <div className={styles.userInfoBlock}>
          <span className={styles.yourChat}>Your chat with</span>
          <UseSmartTooltip className={styles.userInfo} tagType={'span'} update={companyName}>
            <b>{companyName ?? 'no name'}</b>
          </UseSmartTooltip>
          {firstName && (
            <span className={styles.userNameInfo}>
              <b>(manager {firstName})</b>
            </span>
          )}
        </div>

        <div className={styles.interlocutor}>
          <RatingStarSvg fill='var(--color-accent-second-light)' width={20} height={20} />

          <span className={styles.verticalLine} />

          <a href={`mailto:${email}`}>
            <MailSvg height={20} width={20} />
          </a>
        </div>
      </div>
    </div>
  )
})
